/* GCC: amounts in the gift/shipping messages are in the SHOP currency; show them in the buyer's currency. */
window.nsShopMoney = function (amount) {
  var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'AED';
  var rate = window.Shopify && Shopify.currency && parseFloat(Shopify.currency.rate);
  var value = rate && isFinite(rate) && rate > 0 ? amount * rate : amount;
  try { return new Intl.NumberFormat(undefined, { style: 'currency', currency: cur, maximumFractionDigits: 0 }).format(Math.ceil(value)); }
  catch (e) { return cur + ' ' + Math.ceil(value); }
};

// custom code to get currency and convert to euro for the cart 


		// get cart data 
		function getCartData(){
			return $.ajax({
				url: "/cart.js",
				type: "GET",
				dataType: "json",
			}).then(function(cart){
				const cartTotal = cart.total_price / 100;   // convert cents to currency
    			const customerCurrency = Shopify.currency.active; 
				return{
					cartTotal,
      				customerCurrency
				}
			})
		} 
		// convert to EURO (hardened: cached rate + graceful fallback if the FX API fails)
		function convertToEUR(amount, currency) {
		if (currency === (window.nsBaseCur || "EUR")) return Promise.resolve(amount);

		var cacheKey = "ns_eur_rate_" + currency;

		return $.ajax({
			url: "https://open.er-api.com/v6/latest/" + currency,
			type: "GET",
			dataType: "json",
			timeout: 5000
		}).then(function(data) {
			var rateToEUR = data && data.rates ? data.rates.EUR : null;
			if (!rateToEUR || !isFinite(rateToEUR)) { throw new Error("no rate"); }
			try { localStorage.setItem(cacheKey, String(rateToEUR)); } catch (e) {}
			return amount * rateToEUR;
		}).catch(function() {
			var cached = null;
			try { cached = parseFloat(localStorage.getItem(cacheKey)); } catch (e) {}
			if (cached && isFinite(cached)) { return amount * cached; }
			return amount; // last resort: keep the UI functional; checkout pricing is enforced by Shopify
		});
		}
		// calculate euro price 
		function getCartTotalInEUR() {
			return getCartData().then(function(data) {
			return convertToEUR(data.cartTotal, data.customerCurrency);
		});
		}
		// function to update cart attribute 
		function saveEURTotalToCart(totalEUR) {
			return fetch("/cart/update.js", {
				method: "POST",
				headers: { "Content-Type": "application/json" },
				body: JSON.stringify({
				attributes: {
					eur_total: totalEUR
				}
				})
			}).then(res => res.json());
		}
	
// end here 

function updateGiftProgress(cartTotalEUR) {
  if (!window.GIFT_CONFIG) return;
  const cfg = window.GIFT_CONFIG;
  const showGift = !!cfg.showShirtGift;
  const giftGoal = Number(cfg.tshirtGoal) || 150;
  const shippingGoal = Number(cfg.shippingGoal) || 0;
  const wrapper = document.querySelector(".side-cart-progress-bar-area");
  if (!wrapper) return;
  const shippingCheckpoint = document.querySelector(".checkpoint-shipping");
  const giftCheckpoint = document.querySelector(".checkpoint-gift");

  if (!showGift) {
    wrapper.style.display = "none";
    return;
  }
  wrapper.style.display = "";

  // Shipping milestone only renders when it sits below the gift goal.
  const hasShipping = shippingGoal > 0 && shippingGoal < giftGoal;

  const pct = Math.min((cartTotalEUR / giftGoal) * 100, 100);
  wrapper.style.setProperty("--progress", pct + "%");

  if (giftCheckpoint) {
    giftCheckpoint.style.display = "block";
    giftCheckpoint.style.left = "100%";
    giftCheckpoint.dataset.reached = cartTotalEUR >= giftGoal;
  }
  if (shippingCheckpoint) {
    if (hasShipping) {
      shippingCheckpoint.style.display = "block";
      shippingCheckpoint.style.left = ((shippingGoal / giftGoal) * 100) + "%";
      shippingCheckpoint.dataset.reached = cartTotalEUR >= shippingGoal;
    } else {
      shippingCheckpoint.style.display = "none";
    }
  }

  let message = "";
  if (cartTotalEUR >= giftGoal) {
    message = hasShipping
      ? "🎉 <strong>FREE SHIPPING</strong> and <strong>FREE GIFT</strong> unlocked!"
      : "🎉 <strong>FREE GIFT</strong> unlocked!";
  } else if (hasShipping && cartTotalEUR < shippingGoal) {
    message = "Spend <strong>" + nsShopMoney(shippingGoal - cartTotalEUR) + "</strong> more for <strong>FREE SHIPPING</strong>";
  } else if (hasShipping) {
    message = "<strong>FREE SHIPPING</strong> unlocked! Spend <strong>" + nsShopMoney(giftGoal - cartTotalEUR) + "</strong> more for a <strong>FREE GIFT</strong>";
  } else {
    message = "Spend <strong>" + nsShopMoney(giftGoal - cartTotalEUR) + "</strong> more for a <strong>FREE GIFT</strong>";
  }

  $("#progressText").html("<p>" + message + "</p>");
}


$(document).ready(function () {
	'use strict';
	// navbar js start ---
	// (The old >100px nav-fixed toggle here fought with the direction-based
	// handler further down and made the header flicker. Sticky behaviour is
	// now handled by ONE unified controller — see UNIFIED STICKY HEADER.)

	$(".ham-menu").click(function (event) {
		event.stopPropagation();
		$(".sidebar-wrapper").toggleClass("active");
		$(".ham-menu").toggleClass("active");
		$(".sidebar-wrapper-inner").toggleClass("active");
		$("body").toggleClass("active");
	});

	$(".mobile-menu-close-window-btn").click(function (event) {
		event.stopPropagation();
		$(".sidebar-wrapper").toggleClass("active");
		$(".ham-menu").toggleClass("active");
		$(".sidebar-wrapper-inner").toggleClass("active");
		$("body").toggleClass("active");
	});

	// **..mobile-dropdown-accordion js start..**
	$('.sidebar-submenu-open').on('click', function () {
		$(this).parent().find(".megamenu-wrapper").addClass('active');
	});

	$('.sidebar-close-btn').on('click', function () {
		$(this).parent().parent().parent(".megamenu-wrapper").removeClass('active');
	});
	// **..mobile-dropdown-accordion js end..**

	$(".search-bar-open-btn").click(function (event) {
		event.stopPropagation();
		$(".search-bar").toggleClass("active");
		$(".search-bar-window-close-btn").toggleClass("active");
		$("body").toggleClass("active");
	});

	$(".search-bar-window-close-btn").click(function (event) {
		event.stopPropagation();
		$(".search-bar").toggleClass("active");
		$(this).toggleClass("active");
		$("body").toggleClass("active");
	});

	$(".search-close-btn").click(function (event) {
		event.stopPropagation();
		$(".search-bar").toggleClass("active");
		$(".search-bar-window-close-btn").toggleClass("active");
		$("body").toggleClass("active");
	});

	// navbar js end ---

	// cart-sidebar js start---
	$(".cart-sidebar-open-btn").click(function (event) { 
		event.preventDefault();
		$(".cart-sidebar").toggleClass("active");
		$("body").toggleClass("active");
	});

	$(".cart-sidebar-close-window-btn").click(function (event) {
		event.stopPropagation();
		$(".cart-sidebar").removeClass("active");
		$("body").toggleClass("active");
	});

	$(".side-cart-close-btn").click(function (event) {
		event.stopPropagation();
		$(".cart-sidebar").toggleClass("active");
		$("body").toggleClass("active");
	});
	// cart-sidebar js end---

	// --tab js start--
	$('.tab-btn').click(function () {
		$('.tab-nav-item').removeClass('active');
		$(this).parent().addClass('active');
		$('.tab-content-item').hide();

		var activeTab = $(this).attr('href');
		$(activeTab).fadeIn();
		return false;
	});
	// --tab js end--

	$(".card-varient-tap-btn").click(function () {
		$(this).closest(".product-card").find(".product-varient").addClass("active");
	})

	$(".product-varient").click(function (e) {
		e.stopPropagation();
	})

	// **..product-accordion js start..**
	$('.product-accordion-toggle-btn').on('click', function () {
		$(this).next().slideToggle();
		$(this).parent().toggleClass('active');
		$(this).parent().siblings().removeClass('active').find('.product-accordion-item-content').slideUp();
	});
	// **..product-accordion js end..**

	

	$(".card_option").on("change", function () {
		let optionName = "";

		if($(this).hasClass("color_Swatch_option")){
			updateSwiperById($(this).attr("data-media-id"), $(this).closest(".product-card").find(".card-slider"));
			return;
		}

		// Get selected option value
		$(this).closest('.product-options').find(".card_option:checked").each(function (e) {
			optionName += e !== 0 ? "-" : "";
			optionName += $(this).val();
		});
 		let $select = $(this).closest('.product-varient').find('.productSelect');

		$select.find("option").each(function () {
			var txt = $.trim($(this).text());
			if (txt === optionName) {
				var img = $(this).data("img");
				var id = $(this).val();
				$select.val($(this).val()).trigger('change'); // select it
				var price = $(this).data("price");
				var compare_price = $(this).data("compare");
				var available = $(this).data("available");

				if (!available) {
                nsNotify('This option is sold out - please pick another.');
                return;
            }

			// NOTE: gift routing removed here on purpose. Products tagged gift-100 are
			// real catalogue products; buying them normally must always work. Gift adds
			// happen ONLY through the dedicated .gift-add-btn flow.

					$.ajax({
						type:'POST',
						url:'/cart/add.js',
						data: { id: id, quantity: 1 },
						dataType:'json',
						success:function(data) {
							$(".cart-sidebar").addClass("active");
							$("body").addClass("active");
							cart_drawer_update();
						},
						error:function(err) {
							console.log('Error', err);
						}
					})

			
			}
		});
	});

	

	$(".card_option_upsell").on("change", function () {
		let optionName = "";

		

		// Get selected option value
		$(this).closest('.product-options').find(".card_option_upsell:checked").each(function (e) {
			optionName += e !== 0 ? "-" : "";
			optionName += $(this).val();
		});
 		let $select = $(this).closest('.product-varient').find('.productSelect');
 		let $id = $(this).closest('.side-cart-slider-item-content').find('.product_id');

		

		$select.find("option").each(function () {
			var txt = $.trim($(this).text());
			if (txt === optionName) {
				var img = $(this).data("img");
				var id = $(this).val();
				$select.val($(this).val()).trigger('change'); // select it
				var price = $(this).data("price");
				var compare_price = $(this).data("compare");
				var available = $(this).data("available");

				$select.val(id);
				$id.val(id);
			
			}
		});
	});

	// ============================================================
	// CARD COLOR SWATCHES – hover (desktop) / tap (touch) swaps card image
	// ENDRIT
	// ============================================================
	// Instead of touching the original <img> (which causes layout glitches on
	// non-Swiper cards because the slide tree was sized assuming the original
	// image stays in place), we OVERLAY a new <img> on top of .card-image-wrap.
	// The overlay matches the original image's positioning rules exactly, and
	// is removed on mouseleave. The underlying Swiper/slide structure is never
	// touched, so there is no possible layout shift.
	function cardSwatchShowPreview($card, variantImageUrl) {
		if (!variantImageUrl) return;
		var $wrap = $card.find(".card-image-wrap").first();
		if (!$wrap.length) return;

		var $overlay = $wrap.children(".card-color-swatch-preview");
		if (!$overlay.length) {
			$overlay = $('<img class="card-color-swatch-preview" alt="" />');
			$wrap.append($overlay);
		}
		// Only change src when needed (avoids reflow + flicker on rapid hover)
		if ($overlay.attr("src") !== variantImageUrl) {
			$overlay.attr("src", variantImageUrl);
		}
		$overlay.addClass("is-visible");
	}

	function cardSwatchHidePreview($card) {
		$card.find(".card-image-wrap > .card-color-swatch-preview").removeClass("is-visible");
	}

	// Detect true hover devices so we don't double-fire on touch.
	var cardSwatchSupportsHover = (window.matchMedia &&
		window.matchMedia("(hover: hover) and (pointer: fine)").matches);

	if (cardSwatchSupportsHover) {
		// Desktop: hover previews; leaving the card hides the preview.
		$(document).on("mouseenter", ".card-color-swatch", function () {
			var $swatch = $(this);
			if ($swatch.hasClass("is-active")) return; // already showing this one
			var $card = $swatch.closest(".product-card");
			$card.find(".card-color-swatch").removeClass("is-active");
			$swatch.addClass("is-active");
			cardSwatchShowPreview($card, $swatch.attr("data-variant-image"));
		});

		$(document).on("mouseleave", ".product-card", function () {
			var $card = $(this);
			$card.find(".card-color-swatch").removeClass("is-active");
			cardSwatchHidePreview($card);
		});
	} else {
		// Touch: first tap previews the variant; second tap follows the link.
		$(document).on("click", ".card-color-swatch", function (e) {
			var $swatch = $(this);
			if ($swatch.hasClass("is-active")) return; // let the link through
			e.preventDefault();
			var $card = $swatch.closest(".product-card");
			$card.find(".card-color-swatch").removeClass("is-active");
			$swatch.addClass("is-active");
			cardSwatchShowPreview($card, $swatch.attr("data-variant-image"));
		});
	}
	// CARD COLOR SWATCHES end – ENDRIT
});


	// Funktion zum Aktualisieren der Verfügbarkeit
function updateVariantAvailability() {
    let optionName = "";
    
    // Get selected option value
    $("input:radio.option_input:checked").each(function (e) {
        optionName += e !== 0 ? "-" : "";
        optionName += $(this).val();
    });

    $("#productSelect option").each(function () {
        var txt = $.trim($(this).text());
        if (txt === optionName) {
            var img = $(this).data("img");
            var id = $(this).val();
            var price = $(this).data("price");
            var compare_price = $(this).data("compare");
            var available = $(this).data("available");
            var inventory = $(this).data("inventory");
            
            $("#productSelect").val(id);
            $("#product_id").val(id);

            // Prüfe inventory statt available
            window.stockTexts = window.stockTexts || { inStock: '', delivery: '', outOfStock: '' };
            if (inventory > 0) {
                $(".addToCart").removeClass("sold_out");
                $(".atc-text").text("Add To Cart");
                
                $(".product-details-availability-text").html(
                    '<span class="icon"></span>' +
                    '<p>' + window.stockTexts.inStock + ' – ' + window.stockTexts.delivery + '</p>'
                );
                
            } else {
                $(".addToCart").addClass("sold_out");
                $(".atc-text").text("Sold Out");
                
                $(".product-details-availability-text").html(
                    '<span class="icon"></span>' +
                    '<p class="stock_out">' + window.stockTexts.outOfStock + '</p>'
                );
            }

            $(".featured-img").each(function (index) {
                var src = $(this).attr("src").split("?")[0];
                var cleanImg = img.split("?")[0];
                if (src === cleanImg) {
                    swiper2.slideToLoop(index, 500, false);
                }
            });
        }
    });
}



// Beim Laden der Seite ausführen
$(document).ready(function() {
    updateVariantAvailability();
	// get cart data 
		getCartTotalInEUR().then(function(totalEUR) {
		saveEURTotalToCart(totalEUR).then(function() {
			// cart attribute updated
		});
		updateGiftProgress(totalEUR)
	});
	
});

// Bei Änderung der Variante
$(".option_input").on("change", function () {
    var vname = $(this).val();
    $(this).closest('.product-details-varient').find('.selected_option').text(vname);
    updateVariantAvailability();
});

	$('.addToCart').on('click', function(e){
		e.preventDefault();
		const form = $(this).closest('#product_form');
		// NOTE: gift routing removed on purpose. All products added from the product
		// page are normal paid adds. Gift adds happen ONLY via .gift-add-btn.
		$.ajax({
            type:'POST',
            url:'/cart/add.js',
            data:form.serialize(),
            dataType:'json',
            success:function(data) {
                $(".cart-sidebar").addClass("active");
                $("body").addClass("active");
                cart_drawer_update();
            }
        });
	});

	$('.upsellAddToCart').on('click', function(e){
		e.preventDefault();

		$.ajax({
			type:'POST',
			url:'/cart/add.js',
			data:$(this).closest('.upsell_form').serialize(),
			dataType:'json',
			success:function(data) {
				$(".cart-sidebar").addClass("active");
				$("body").addClass("active");
				cart_drawer_update();
			},
			error:function(err) {
				console.log('Error', err);
			}
		})
	})
//custom gift code
	$(document).on('click', '.gift-add-btn', function(e) {
		e.preventDefault();
		const parent = $(this).closest(".gift-item");
		const variantId = parent.find(".gift-variant-select").val();
		if (!variantId) { return; }
		// gift function
		tryAddGift(variantId);
	})
//end here 

// Toast notifications are disabled store-wide (merchant request — they were
// intrusive mid-action). Kept as a no-op, not deleted, so every call site
// (gift/cart flows, `typeof nsNotify === 'function'` guards) keeps working.
function nsNotify(message) {}

// custom Code 
var giftAddInFlight = false;
async function tryAddGift(variantId, _a, _b, callback) {

	if (giftAddInFlight) { return; }
	giftAddInFlight = true;

	const { tshirtGoal } = window.GIFT_CONFIG || { tshirtGoal: 150 };
	const totalEUR = await getCartTotalInEUR();
	const totalNum = Number(totalEUR.toFixed(2));

    $.ajax({
        url: "/cart.js",
        type: "GET",
        dataType: "json",
        success: function (cart) {

            const giftExists = cart.items.some(item =>
                item.properties && item.properties.gift
            );

            // Stop if gift already exists
            if (giftExists) {
                giftAddInFlight = false;
                nsNotify("You have already selected your free gift.");
                return;
            }

            // Stop if not eligible
            if (totalNum < tshirtGoal) {
                giftAddInFlight = false;
                nsNotify("Spend " + nsShopMoney(tshirtGoal - totalNum) + " more to unlock your free gift.");
                return;
            }

            // If all checks passed -> ADD GIFT
            $.ajax({
                type: "POST",
                url: "/cart/add.js",
                data: {
                    id: variantId,
                    quantity: 1,
                    properties: {
                        gift: "Free Gift"
                    }
                },
                dataType: "json",
                success: function () {
                    giftAddInFlight = false;
                    nsNotify("Your free gift was added to the cart!");
                    cart_drawer_update();
                    $(".cart-sidebar").addClass("active");
                    $("body").addClass("active");
                    if (callback) callback();
                },
                error: function (xhr) {
                    giftAddInFlight = false;
                    console.error("Error adding gift:", xhr.responseText);
                }
            });
        },
        error: function () {
            giftAddInFlight = false;
        }
    });
}

// End Here 

/* =====================================================================
   UNIFIED STICKY HEADER
   Replaces the two previous competing scroll handlers (one toggled
   nav-fixed at >100px, the other hid/showed on a raw 22px delta) whose
   fights made the header flicker back and forth on small scroll jitter.
   One rAF-throttled controller with hysteresis; the mode comes from the
   header section's theme-editor setting via window.__nsHeaderSticky:
     'always' - sticky and always visible
     'smart'  - sticky; hides on a decisive scroll down, returns on scroll up
     'none'   - static header, no stickiness
   ===================================================================== */
const navbar = document.querySelector(".navbar");
(function () {
	if (!navbar) return;
	var lastY = window.pageYOffset;
	var acc = 0;
	var ticking = false;

	function applyHeaderState() {
		ticking = false;
		var mode = window.__nsHeaderSticky || 'always';
		var y = window.pageYOffset;
		var dy = y - lastY;
		lastY = y;

		if (mode === 'none') {
			navbar.classList.remove('nav-fixed', 'hide');
			return;
		}
		// At (or rubber-banding around) the top: plain header, reset state.
		if (y <= 12) {
			navbar.classList.remove('nav-fixed', 'hide');
			acc = 0;
			return;
		}
		navbar.classList.add('nav-fixed');
		if (mode === 'always') {
			navbar.classList.remove('hide');
			return;
		}
		// 'smart': accumulate movement in one direction; only act on a
		// DECISIVE gesture so tiny jitter can never flip the header.
		if ((dy > 0 && acc < 0) || (dy < 0 && acc > 0)) acc = 0;
		acc += dy;
		if (acc > 90 && y > 180) {
			navbar.classList.add('hide');
			acc = 0;
		} else if (acc < -16) {
			navbar.classList.remove('hide');
			acc = 0;
		}
	}

	window.addEventListener('scroll', function () {
		if (!ticking) {
			ticking = true;
			requestAnimationFrame(applyHeaderState);
		}
	}, { passive: true });
	// Correct initial state on load (e.g. reload mid-page).
	applyHeaderState();
})();


// btn js ---
// primary btn---
$(function () {
	$('.primary-btn')
		.on('mouseenter', function (e) {
			var parentOffset = $(this).offset(),
				relX = e.pageX - parentOffset.left,
				relY = e.pageY - parentOffset.top;
			$(this).find('span').css({
				top: relY,
				left: relX
			})
		})
		.on('mouseout', function (e) {
			var parentOffset = $(this).offset(),
				relX = e.pageX - parentOffset.left,
				relY = e.pageY - parentOffset.top;
			$(this).find('span').css({
				top: relY,
				left: relX
			})
		});
});

// secondary btn--
$(function () {
	$('.secondary-btn')
		.on('mouseenter', function (e) {
			var parentOffset = $(this).offset(),
				relX = e.pageX - parentOffset.left,
				relY = e.pageY - parentOffset.top;
			$(this).find('span').css({
				top: relY,
				left: relX
			})
		})
		.on('mouseout', function (e) {
			var parentOffset = $(this).offset(),
				relX = e.pageX - parentOffset.left,
				relY = e.pageY - parentOffset.top;
			$(this).find('span').css({
				top: relY,
				left: relX
			})
		});
});
// btn js ---

// card slider js start--

  /* Speed (Walter, 28 Sep): every product card has its own image slider and all of them (100+ on the home page)
     were started at once on page load. Now a card's slider starts when the card comes near the screen, or at once
     when code needs it (colour swatch -> updateSwiperById). Cards added later (filters, load more) are picked up. */
  var nsCardOpts = {
    slidesPerView: 1,
    spaceBetween: 4,
    loop: false,
    navigation: {
      nextEl: ".card-slider-button-next",
      prevEl: ".card-slider-button-prev",
    },
  };
  function nsInitCard(el) {
    if (!el || el.swiper || el.dataset.nsSwiper) return el && el.swiper;
    el.dataset.nsSwiper = '1';
    /* Adam 2 Oct: a card inside a sideways-scrolling row (e.g. Fall/Winter on mobile) must not grab the swipe,
       otherwise the photos move instead of the row. Photos still change via colour dots and arrows. */
    var opts = nsCardOpts;
    for (var a = el.parentElement; a && a !== document.body; a = a.parentElement) {
      var ox = getComputedStyle(a).overflowX;
      if ((ox === 'auto' || ox === 'scroll') && a.scrollWidth > a.clientWidth + 4) { opts = Object.assign({}, nsCardOpts, { allowTouchMove: false }); el.style.touchAction = 'pan-x pan-y'; break; }
    }
    return new Swiper(el, opts);
  }
  window.nsInitCard = nsInitCard;
  (function () {
    if (!('IntersectionObserver' in window)) { document.querySelectorAll('.card-slider').forEach(nsInitCard); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { io.unobserve(e.target); nsInitCard(e.target); } });
    }, { rootMargin: '300px 300px' });
    var watch = function () {
      document.querySelectorAll('.card-slider:not([data-ns-watch])').forEach(function (el) { el.setAttribute('data-ns-watch', ''); io.observe(el); });
    };
    watch();
    var queued = false;
    new MutationObserver(function () {
      if (queued) return; queued = true;
      requestAnimationFrame(function () { queued = false; watch(); });
    }).observe(document.body, { childList: true, subtree: true });
  })();


function updateSwiperById(id, swatches) {
	var slides = swatches.find(".swiper-slide")
	var index = 0;
	for (let i = 0; i < slides.length; i++) {
		const element = $(slides[i]).attr("data-media-id");

		if (element == id) {
			index = i;
		}
		
	}

	var sw = $(swatches)[0].swiper || nsInitCard($(swatches)[0]);
	if (sw) sw.slideTo(index)
}

// card slider js end--


var swiper = new Swiper(".side-cart-item-slider", {
	slidesPerView: 1.5,
	spaceBetween: 10,
	grabCursor: true,
	loop: false,
	navigation: {
		nextEl: '.side-cart-slider-btn-next',
		prevEl: '.side-cart-slider-btn-prev',
	},
	breakpoints: {
		1: {
			slidesPerView: 1.2,
		},
		440: {
			slidesPerView: 1.5,
		}
	}
});
// side-cart-item-slider js end--

// img-gallery slider js start--
var swiper = new Swiper(".img-gallery-slider", {
	infinity: true,
	slidesPerView: 4.5,
	spaceBetween: 4,
	grabCursor: true,
	loop: true,
	speed: 500,
	 autoplay: {
		delay: 4000,
		disableOnInteraction: true,
		
	},
	breakpoints: {
		// when window width is >= 320px
		1: {
			slidesPerView: 1.25,
		},
		// when window width is >= 768px
		576: {
			slidesPerView: 3.2,
		},
		// when window width is >= 993px
		993: {
			slidesPerView: 3.5,
		},
		// when window width is >= 1140x
		1140: {
			slidesPerView: 4.5,
		},
		// when window width is >= 1290px
		1290: {
			slidesPerView: 4.5,
		}
	}
});
// img-gallery slider js end--

// testimonial slider js start--
var swiper = new Swiper(".testimonial-slider", {
	slidesPerView: 3.5,
	spaceBetween: 10,
	grabCursor: true,
	loop: false,
	scrollbar: {
		el: ".swiper-scrollbar",
		hide: true,
	},
	breakpoints: {
		// when window width is >= 320px
		1: {
			slidesPerView: 1.1,
		},
		// when window width is >= 768px
		576: {
			slidesPerView: 2.3,
		},
		// when window width is >= 993px
		993: {
			slidesPerView: 2.7,
		},
		// when window width is >= 1140x
		1140: {
			slidesPerView: 3.3,
		},
		// when window width is >= 1290px
		1290: {
			slidesPerView: 3.5,
		}
	}
});

var swiper = new Swiper(".announcement-slider", {
	slidesPerView: 1,
	loop: true,
	speed: 1000,
	autoplay: {
		delay: 4000,
		disableOnInteraction: true,
		
	},
});
// testimonial slider js end--

// product slider js start--
let mql = window.matchMedia("(max-width: 767px)");
if (mql.matches) {
	var swiper = new Swiper(".product-details-thumb-slider", {
		loop: false,
		spaceBetween: 2,
		slidesPerView: 4.2,
		breakpoints: {
			1: {
				slidesPerView: 4.2,
			},
			576: {
				slidesPerView: 5.2,
			}
		}
	});
	var swiper2 = new Swiper(".product-details-slider", {
		spaceBetween: 0,
		direction: "vertical",
		slidesPerView: "auto",
		freeMode: true,
		mousewheel: true,
		scrollbar: {
			el: ".swiper-scrollbar",
		},
		thumbs: {
			swiper: swiper,
		},
		breakpoints: {
			1: {
				freeMode: false,
				spaceBetween: 5,
				slidesPerView: 1,
				mousewheel: false,
				direction: "horizontal",
			},
			576: {
				freeMode: false,
				spaceBetween: 5,
				slidesPerView: 1,
				mousewheel: false,
				direction: "horizontal",
			},
			767: {
				spaceBetween: 0,
				direction: "vertical",
				slidesPerView: "auto",
				freeMode: true,
				mousewheel: true,
			},
			1024: {
				spaceBetween: 0,
				direction: "vertical",
				slidesPerView: "auto",
				freeMode: true,
				mousewheel: true,
			}
		}
	});
} else {
	var swiper2 = new Swiper(".product-details-slider", {
		spaceBetween: 0,
		direction: "vertical",
		slidesPerView: "auto",
		freeMode: true,
		mousewheel: true,
		scrollbar: {
			el: ".swiper-scrollbar",
		},
	});

}

// product slider js end--
function disableCheckout(disable) {
  const btn = document.querySelector('[name="checkout"]');
  if (!btn) return;

  btn.disabled = disable;
  btn.classList.toggle('disabled', disable);
}


// cart item increase
function itemPlus(e, el) {
disableCheckout(true)
  var id = $(el).data("id");
  var qty = $(el).prev().val();
  qty = parseInt(qty) + 1;
  var $this = $(e);

  $.ajax({
    type: "POST",
    url: "/cart/change.js",
    data: {
      id: parseFloat(id),
      quantity: qty,
    },
    dataType: "json",
    success: function (data) {
      cart_drawer_update();
      $(el).prev().val(qty);
    },
    error: function (err) {
      console.log("Error");
    },
  });
}
// cart item decrease
function itemMinus(e, el) {
	disableCheckout(true)
  var id = $(el).data("id");
  var qty = $(el).next().val();
  qty = parseInt(qty) - 1;
  var $this = $(e);

  $.ajax({
    type: "POST",
    url: "/cart/change.js",
    data: {
      id: parseFloat(id),
      quantity: qty,
    },
    dataType: "json",
    success: function (data) {
      cart_drawer_update();
      if (qty >= 1) {
		
        $(el).next().val(qty);
      }
    },
    error: function (err) {
      console.log("Error");
    },
  });
}
// cart item Remove
function itemRemoved(e, el) {
	disableCheckout(true)
  var id = $(el).data("id");
  $.ajax({
    type: "POST",
    url: "/cart/change.js",
    data: {
      id: parseFloat(id),
      quantity: 0,
    },
    dataType: "json",
    success: function (data) {
      cart_drawer_update();
    },
    error: function (err) {
      console.log("Error");
    },
  });
}

function removeGiftItem(itemKey) {
  fetch("/cart/change.js", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      id: itemKey,
      quantity: 0
    })
  }).then(() => {
    cart_drawer_update();
  });
}


// reload function
function sideCartHTML() {
  fetch("/?section_id=side-cart")
    .then(res => res.text())
    .then(html => {
      var cart_html = $(html);
      $("#gift-offer-dynamic").html(
		$("#gift-offer-dynamic", cart_html).html()
		);
      $("#cart_items").html($("#cart_items", cart_html).html());
      $(".cart_footer").html($(".cart_footer", cart_html).html());
    });
}

async function cart_drawer_update() {
	const { cartTotal, customerCurrency } = await getCartData();
	const giftConfig = window.GIFT_CONFIG || { tshirtGoal: 150 };
	const tshirtGoal = giftConfig.tshirtGoal;
	const eurTotal = Number((await convertToEUR(cartTotal, customerCurrency)).toFixed(2));
	updateGiftProgress(eurTotal);

  $.getJSON("/cart.js", function (cart) {
	// Qualifying spend = non-gift items at their original price. This matches the
	// Buy X Get Y rule ("spend X"), where the gift item itself does NOT count toward
	// the threshold. Without this, a shopper could add the gift at the goal and then
	// remove other items while the gift's own price kept the total above the goal,
	// leaving an unqualified gift that would be charged at checkout.
	var nonGiftMinor = 0;
	var hasGift = false;
	cart.items.forEach(function (item) {
		if (item.properties && item.properties.gift) { hasGift = true; return; }
		nonGiftMinor += item.original_line_price;
	});
	if (hasGift) {
		convertToEUR(nonGiftMinor / 100, customerCurrency).then(function (nonGiftEur) {
			if (Number(nonGiftEur) < tshirtGoal) {
				disableCheckout(true);
				cart.items.forEach(function (item) {
					if (item.properties && item.properties.gift) { removeGiftItem(item.key); }
				});
			}
		});
	}
	//  end here
    var total_items = cart.item_count;

	if(total_items > 0) {
		$('.cart-sidebar').removeClass('empty_cart')
		$("#giftOffer").css("display", "block");
	}else {
		$('.cart-sidebar').addClass('empty_cart')
		$("#giftOffer").css("display", "none");
	}

    $(".side-cart-item-number").text(total_items);
	$(".cart_count").text(total_items);   
  });


	getCartTotalInEUR().then(function(totalEUR) {
		saveEURTotalToCart(totalEUR).then(function() {
			 sideCartHTML();
			 disableCheckout(false)
		});
	});

}



// timer js start--
var timeInSecs;
var ticker;

function startTimer(secs) {
	timeInSecs = parseInt(secs);
	ticker = setInterval(tick, 1000);
}

function tick() {
	var secs = timeInSecs;
	if (secs > 0) {
		timeInSecs--;
	} else {
		clearInterval(ticker);
		startTimer(timerMinutes * 60); // restart using the configured Reserved Time
	}

	var mins = Math.floor(secs / 60);
	secs %= 60;
	var pretty = ((mins < 10) ? "0" : "") + mins + ":" + ((secs < 10) ? "0" : "") + secs;

	var timerDisplayEl = document.getElementById("side_cart_timer");
	if (timerDisplayEl) { timerDisplayEl.innerHTML = pretty; }
}

var timerStartEl = document.getElementById("side_cart_timer");
var timerMinutes = 10;
if (timerStartEl && timerStartEl.dataset && timerStartEl.dataset.minutes) {
	var parsedTimerMinutes = parseInt(timerStartEl.dataset.minutes, 10);
	if (parsedTimerMinutes > 0 && isFinite(parsedTimerMinutes)) { timerMinutes = parsedTimerMinutes; }
}
startTimer(timerMinutes * 60); // minutes come from the Cart Drawer "Reserved Time" setting
// timer js end--

// progesss-bar js start--
const progress = document.querySelector('.progress');
if (progress) {
progress.addEventListener('input', function () {
	const value = this.value;
	this.style.background = 'linear-gradient(to right,rgb(36, 40, 51) 0%,rgb(36, 40, 51) ' + value + '%,rgb(216, 216, 216) ' + value + '%)'
})
}
// progesss-bar js end--


new Swiper(".megaSwipertitle", {
		slidesPerView: 3.5,
		spaceBetween: 5,
		navigation: {
		nextEl: ".swiper-button-nexttitle",
		prevEl: ".swiper-button-prevtitle",
	},
	breakpoints: {
		0: {
			slidesPerView: 3.3,
		},
		768: {
			slidesPerView: 3.3,
		},
		1024: {
			slidesPerView: 3.5,
		},
	},
});

document.querySelectorAll(".product-slider__buttons").forEach((btnWrapper) => {
  const btn = btnWrapper.querySelector(".swiper-button-next, .swiper-button-prev");
  if (!btn) return;

  btnWrapper.addEventListener("mousemove", (e) => {
    const rect = btnWrapper.getBoundingClientRect();
    const x = e.clientX - rect.left - btn.offsetWidth / 2;
    const y = e.clientY - rect.top - btn.offsetHeight / 2;

    btn.style.transform = "translate(" + x + "px, " + y + "px)";
  });

  btnWrapper.addEventListener("mouseleave", () => {
    btn.style.transform = "translate(0, 0)";
  });
});


/* Speed: autoplaying sliders (1 s interval) kept the page busy even off screen. Run them only while visible. */
function nsAutoplayWhenVisible(el, swipers) {
  if (!el || !('IntersectionObserver' in window)) return;
  swipers.forEach(function (sw) { sw && sw.autoplay && sw.autoplay.stop(); });
  new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      swipers.forEach(function (sw) { if (sw && sw.autoplay) { e.isIntersecting ? sw.autoplay.start() : sw.autoplay.stop(); } });
    });
  }).observe(el);
}
document.querySelectorAll(".product-slider__section").forEach(function(section) {
    const wrapper = section.querySelector(".product-slider__wrapper");
    const mainSlider = section.querySelector(".product-slider__product-swiper");
    const thumbSlider = section.querySelector(".product-slider__image-swiper");
    const nextBtn = section.querySelector(".product-slider__buttons.product-button-next");
    const prevBtn = section.querySelector(".product-slider__buttons.product-button-prev");
    const paginationEl = section.querySelector(".product-slider__pagination.swiper-pagination");
    const swiperMain = new Swiper(mainSlider, {
        loop: true,
        slidesPerView: 1,
        spaceBetween: 10,
        speed: 1000,
        keyboard: true,
        autoplay: {
            delay: 1000,
            disableOnInteraction: false,
        },
        pagination: {
            el: paginationEl,
            clickable: true,
        },
        navigation: {
            nextEl: nextBtn,
            prevEl: prevBtn,
        },
        effect: "slide",
    });

    const swiperThumb = new Swiper(thumbSlider, {
        loop: true,
        slidesPerView: 1,
        spaceBetween: 10,
        speed: 1000,
        watchSlidesProgress: true,
        effect: "slide",
        breakpoints: {
            0: {
                autoplay: {
                    delay: 1000,
                    disableOnInteraction: false,
                },
            },
            767: {
                autoplay: {
                    delay: 1000,
                    disableOnInteraction: false,
                },
            },
        },
    });

    swiperMain.controller.control = swiperThumb;
    swiperThumb.controller.control = swiperMain;
    nsAutoplayWhenVisible(section, [swiperMain, swiperThumb]);
	
    wrapper.addEventListener("mouseenter", function() {
        swiperMain.autoplay?.stop();
        swiperThumb.autoplay?.stop();
    });
    wrapper.addEventListener("mouseleave", function() {
        swiperMain.autoplay?.start();
        swiperThumb.autoplay?.start();
    });
});



const swipe = new Swiper('.bestseller-section .product-slider__image-swiper', {
	loop: true,
	slidesPerView: 1,
	spaceBetween: 10,
	speed: 1000,
	watchSlidesProgress: true,
	effect: "slide",
	autoplay: {
		delay: 1000,
		disableOnInteraction: false,
	},
});
if (swipe && !Array.isArray(swipe)) nsAutoplayWhenVisible(document.querySelector('.bestseller-section'), [swipe]);
